'use strict';

var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
require('prop-types');
var classnames = require('classnames');
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a() {
      if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function () {
        return n[k];
      }
    });
  });
  return a;
}
const RECOMMENDATIONS_HEART_EMPTY = 'recommendations-heart-empty';
const RECOMMENDATIONS_HEART_FULL = 'recommendations-heart-full';
const RECOMMENDATIONS_FULL_ICON = 'recommendations-full_icon';
const RECOMMENDATIONS_CHEVRON = 'recommendations-chevron';
const RECOMMENDATIONS_START_EMPTY = 'recommendations-star-empty';
const RECOMMENDATIONS_START_HALF = 'recommendations-star-half';
const RECOMMENDATIONS_START_FULL = 'recommendations-star-full';
const RECOMMENDATIONS_MELI_LOGO = 'recommendations-meli_logo';
const RECOMMENDATIONS_MELI_COINS = 'recommendations-meli_coins';
const RECOMMENDATIONS_CPG_ICON = 'recommendations-cpg_icon';
const RECOMMENDATIONS_CBT_ICON = 'recommendations-cbt_icon';
const RECOMMENDATIONS_BLACK_FRIDAY_ICON = 'recommendations-black-friday_icon';
const RECOMMENDATIONS_MELICHOICE_LOGO = 'recommendations-melichoice_logo';
const RECOMMENDATIONS_BUFLO_ICON_INFO = 'recommendations-buflo_icon_info';
const RECOMMENDATIONS_MSHOPS_LOGO = 'recommendations-mshops_logo';
const RECOMMENDATIONS_CLOCK_ICON = 'recommendations-clock_icon';
const RECOMMENDATIONS_STORE_ICON = 'recommendations-store_icon';
const RECOMMENDATIONS_FIRE_ICON = 'recommendations-fire_icon';
const RECOMMENDATIONS_BADGE_ICON = 'recommendations-badge_icon';
const RECOMMENDATIONS_INFO_ICON = 'recommendations-info_icon';
const RECOMMENDATIONS_APPAREL_ICON = 'recommendations-clothing_icon';
const RECOMMENDATIONS_BEAUTY_ICON = 'recommendations-beauty_icon';
const RECOMMENDATIONS_TOOLS_ICON = 'recommendations-tools_icon';
const RECOMMENDATIONS_SUPERMARKET_ICON = 'recommendations-super_icon';
const RECOMMENDATIONS_DECO_ICON = 'recommendations-furniture_icon';
var icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RECOMMENDATIONS_APPAREL_ICON: RECOMMENDATIONS_APPAREL_ICON,
  RECOMMENDATIONS_BADGE_ICON: RECOMMENDATIONS_BADGE_ICON,
  RECOMMENDATIONS_BEAUTY_ICON: RECOMMENDATIONS_BEAUTY_ICON,
  RECOMMENDATIONS_BLACK_FRIDAY_ICON: RECOMMENDATIONS_BLACK_FRIDAY_ICON,
  RECOMMENDATIONS_BUFLO_ICON_INFO: RECOMMENDATIONS_BUFLO_ICON_INFO,
  RECOMMENDATIONS_CBT_ICON: RECOMMENDATIONS_CBT_ICON,
  RECOMMENDATIONS_CHEVRON: RECOMMENDATIONS_CHEVRON,
  RECOMMENDATIONS_CLOCK_ICON: RECOMMENDATIONS_CLOCK_ICON,
  RECOMMENDATIONS_CPG_ICON: RECOMMENDATIONS_CPG_ICON,
  RECOMMENDATIONS_DECO_ICON: RECOMMENDATIONS_DECO_ICON,
  RECOMMENDATIONS_FIRE_ICON: RECOMMENDATIONS_FIRE_ICON,
  RECOMMENDATIONS_FULL_ICON: RECOMMENDATIONS_FULL_ICON,
  RECOMMENDATIONS_HEART_EMPTY: RECOMMENDATIONS_HEART_EMPTY,
  RECOMMENDATIONS_HEART_FULL: RECOMMENDATIONS_HEART_FULL,
  RECOMMENDATIONS_INFO_ICON: RECOMMENDATIONS_INFO_ICON,
  RECOMMENDATIONS_MELICHOICE_LOGO: RECOMMENDATIONS_MELICHOICE_LOGO,
  RECOMMENDATIONS_MELI_COINS: RECOMMENDATIONS_MELI_COINS,
  RECOMMENDATIONS_MELI_LOGO: RECOMMENDATIONS_MELI_LOGO,
  RECOMMENDATIONS_MSHOPS_LOGO: RECOMMENDATIONS_MSHOPS_LOGO,
  RECOMMENDATIONS_START_EMPTY: RECOMMENDATIONS_START_EMPTY,
  RECOMMENDATIONS_START_FULL: RECOMMENDATIONS_START_FULL,
  RECOMMENDATIONS_START_HALF: RECOMMENDATIONS_START_HALF,
  RECOMMENDATIONS_STORE_ICON: RECOMMENDATIONS_STORE_ICON,
  RECOMMENDATIONS_SUPERMARKET_ICON: RECOMMENDATIONS_SUPERMARKET_ICON,
  RECOMMENDATIONS_TOOLS_ICON: RECOMMENDATIONS_TOOLS_ICON
});
var require$$0 = /*@__PURE__*/getAugmentedNamespace(icons);
var constants = require$$0;
var _path, _path2, _rect;
const namespace = 'ui-recommendations-icon';

/* eslint-disable max-len */
const ToolsIcon = _ref => {
  let {
    className = null
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    className: classnames(namespace, className),
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _path || (_path = /*#__PURE__*/_jsx("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7093 12.8902L27.6243 15.9612L24.0243 12.3782L27.1083 9.30722C26.3734 9.09796 25.6124 8.99458 24.8483 9.00022C21.8899 9.25444 19.6388 11.7647 19.7073 14.7332C19.7004 15.2943 19.8055 15.8512 20.0163 16.3712L10.1453 25.0712C9.4539 25.6882 9.04182 26.5588 9.00301 27.4847C8.9642 28.4105 9.30196 29.3126 9.93929 29.9852V29.9852C10.5931 30.668 11.509 31.0368 12.4536 30.9976C13.3982 30.9584 14.2803 30.5149 14.8753 29.7802L23.6143 19.9532C24.5483 20.2267 25.5304 20.2949 26.4933 20.1532C28.5613 19.7254 30.2233 18.1892 30.8123 16.1612C31.0871 15.083 31.0514 13.949 30.7093 12.8902V12.8902Z",
    stroke: "#3483fa",
    strokeWidth: "1.5",
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/_jsx("rect", {
    x: "0.5",
    y: "0.5",
    width: "39",
    height: "39",
    rx: "19.5",
    stroke: "#EDEDED"
  })));
};
const ToolsIconconMemo = /*#__PURE__*/React.memo(ToolsIcon);
ToolsIconconMemo.ICON_ID = constants.RECOMMENDATIONS_TOOLS_ICON;
var ToolsIconconMemo$1 = ToolsIconconMemo;
module.exports = ToolsIconconMemo$1;
